import '../Sass/App.scss';
import React, { useContext, useEffect, useState } from 'react';
import LinearProgress from '@mui/material/LinearProgress';
import { CartContext } from '../Contexts/CartContext';
import { AuthContext } from '../Contexts/AuthContext';
import { apiFetch } from '../Helpers/api';

export function DocNav(props) {

    const cart = useContext(CartContext);
    const auth = useContext(AuthContext);
    const [codebases, setCodebases] = useState([]);
    const [dataLoaded, setDataLoaded] = useState(false);
    const inCart = props.codebaseInfo?.codebase_id ? cart.isInCart(props.codebaseInfo.codebase_id) : false;
    const canPlaytest = Boolean(props.canPlaytest);
    const targetCardCount = 24;
    const cardCount = (props.deck || []).reduce((total, cardSet) => {
        return total + (cardSet.cards || []).reduce((setTotal, card) => {
            const quantity = parseInt(card.quantity, 10);
            return setTotal + (Number.isFinite(quantity) && quantity > 0 ? quantity : 1);
        }, 0);
    }, 0);
    const remainingCards = targetCardCount - cardCount;

    useEffect(() => {
        if (auth.loading) {
            return;
        }

        setDataLoaded(false);
        apiFetch("codebases.php")
            .then((res) => res.json())
            .then((json) => {
                setCodebases(json.data || []);
                setDataLoaded(true);
            })
            .catch(() => {
                setCodebases([]);
                setDataLoaded(true);
            });
    }, [auth.loading, auth.user?.user_id]);

    function selectCodebase(event) {
        props.selectCodebase(event.target.value);
    }

    function getCardTitle(card) {
        return (
            (card.name_1 ? card.name_1 : '') +
            (card.name_2 ? card.name_2 : '') +
            (String(card.include_parentheses) === '1' ? '(' + card.argument + ')' : '') +
            (card.suffix ? card.suffix : '')
        );
    }

    function playtestCodebase() {
        if (props.changePage && canPlaytest) {
            props.changePage('playtest engine', props.codebase);
        }
    }

    function toggleEditing() {
        if (props.canEdit) {
            props.setEditing(!props.editing);
        }
    }

    return (
        <>
                {dataLoaded ? ( <>
                    <div className="codebase-select-div">
                        <select className="codebase-select" onChange={selectCodebase} value={props.codebase}>
                            {codebases.map((codebase) =>
                                <option value={codebase.codebase_id} key={codebase.codebase_id}>
                                    {codebase.name}
                                </option>
                            )}
                        </select>
                
                    </div>
                    {props.canEdit && (
                        <button className={props.editing ? "cli-button-white" : "cli-button"} onClick={toggleEditing}>
                            {props.editing ? 'stop editing' : 'edit codebase'}
                        </button>
                    )}
                    {/* <button className="cli-button">view in store</button> */}
                    {props.codebaseInfo && (
                        <button className={inCart ? "cli-button-white" : "cli-button"} onClick={() => cart.addCodebase(props.codebaseInfo)}>
                            {inCart ? 'in cart' : `add to cart ($${Number(props.codebaseInfo?.price || 0).toFixed(2)})`}
                        </button>
                    )}
                    <button className="cli-button" onClick={playtestCodebase} disabled={!canPlaytest}>
                        {canPlaytest ? 'playtest' : 'playtest locked'}
                    </button>
                </> ) : <LinearProgress color="success" />}
            {(props.deck || []).map((cardSet) =>
                <React.Fragment key={cardSet.card_type}>
                    <h2>{cardSet.card_type}</h2>
                    <ul className='docs-list'>
                        {cardSet.cards.map((card) =>
                            <li key={card.card_id || card.id} onClick={() => props.expandCard(card)}>
                                {getCardTitle(card)}
                            </li>
                        )}
                    </ul>
                </React.Fragment>
            )}
            {props.editing && (
                <div className="docs-card-counter">
                    <div className="green-code">card count</div>
                    <div className="white-code">{cardCount}/{targetCardCount}</div>
                    <div className="docs-card-counter-bar">
                        <div
                            className="docs-card-counter-fill"
                            style={{width: `${Math.min((cardCount / targetCardCount) * 100, 100)}%`}}
                        />
                    </div>
                    <div className="grey-code">
                        {remainingCards > 0
                            ? `${remainingCards} more to standard deck`
                            : remainingCards === 0
                                ? 'standard deck target reached'
                                : `${Math.abs(remainingCards)} over standard deck`}
                    </div>
                </div>
            )}
        </>
    );
}
